export default {
    "msg": {
        "8": "8",
        "20": "20",
        "250": "250",
        "Enter a new password": "新しいパスワードを入力します",
        "Empty": "空",
        "No data": "データなし",
        "Installation Package List": "インストール・パッケージ・リスト",
        "Update Package": "更新パッケージ",
   
        "Settings - Profiles": "設定 - プロファイル",
        "User Management": "ユーザー管理",
        "Operation Records": "オペレーションレコード",
        "Exit": "終了",
        "Total pages:": "総ページ数: ",
        "page": "ページ",
        "Go to": "移動",
        "Prev": "前へ",
        "Next": "次へ",
        "per page": "各ページ",
        "items": " ",
        "Please enter the page number to go to": "请输入前往页数",
        "Language": "言語",
        "Profile Picture": "プロファイル画像",
        "Old Password": "古いパスワード",
        "New Password": "新しいパスワード",
        "Confirm Password": "パスワードの確認",
        "The two passwords entered do not match": "入力された 2 つのパスワードが一致しません",
        "Enter the new password again": "新しいパスワードをもう一度入力し.",
        "This must match the new password above": "これは上記の新しいパスワードと一致する必要があります",
        "Invalid input。Password length must be 8–16 characters": "無効な入力です。パスワードの長さは 8 〜 16 文字にしてください",
        "Lenovo Privacy Statement": "Lenovo のプライバシーに関する声明",
        "Lenovo Software License Agreement": "Lenovo ソフトウェア・ライセンス契約",
        "Third-Party Notice": "サードパーティ通知",
        "Third-party notifications":"サードパーティの通知",
        "Change Password": "パスワードの変更",
        "Edit Profile": "プロファイルの編集",
        "Exited successfully": "正常に終了しました",
        "Admin": "管理者",
        "Common user": "一般ユーザー",
        "Super Admin":"スーパー管理者",
        "Model": "モデル",
        "Are you sure you want to delete this?": "これを削除してもよろしいですか?",
        "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters": "新しいパスワードを入力します。大文字、小文字、数字、特殊文字のうち少なくとも 3 つを含める必要があります。",
        "It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters": "大文字、小文字、数字、特殊文字のうち少なくとも 3 つを含める必要があります。",
        "Tip": "ヒント",
        "Confirm": "確認",
        "Cancel": "キャンセル",
        "Deletion successful": "削除に成功しました",
        "Password changed successfully": "パスワードが正常に変更されました",
        "The file to upload is larger than 100 MB。 Please select another one。": "アップロード・ファイルが 100 MB を超えています。別のファイルを選択してください。",
        "Your session has expired。 Please log in again。": "現在のログインステータスが期限切れになっているので、再ログインしてください！",
        "Invalid network request URL": "ネットワーク要求アドレスが正しくありません！",
        "Unknown server error": "サーバで不明なエラーが発生しました！",
        "An unknown error has occurred": "未知のエラーが発生しました！",
        "Request timeout。 Please check your network and try again": "要求がタイムアウトしました。ネットワークを確認して、再試行してください。",
        "Failed to connect to server": "サーバーに接続できませんでした",
        "Your network may be currently disconnected": "ネットワークが現在切断されている可能性があります",
        "No related device found": "関連機器が見つかりませんでした",
        "Pre-upgrade component not found in the device": "デバイス内のアップグレード済みコンポーネントが見つかりませんでした",
        "FWID of the installation component not found": "インストールコンポーネントFWIDが見つかりません",
        "Failed to set upgrade information": "アップグレード情報の設定に失敗しました",
        "Failed to set specified update options": "更新設定の指定に失敗しました",
        "Failed to install the update package": "アップデートパッケージのインストールに失敗しました",
        "Failed to obtain the device handle": "デバイスハンドルの取得に失敗しました",
        "Upgrade device mismatch": "升级设备不匹配",
        "Installation failed: Pre-upgrade component not found in the device": "インストールできませんでした：デバイスにアップグレード済みコンポーネントが見つかりませんでした",
        "Installation failed: FWID mismatch in the component list": "インストールできません：コンポーネントのFWIDが一致しません",
        "Installation failed: No matching monitor found for upgrade": "インストールできませんでした：アップグレードが一致するモニタが見つかりませんでした",
        "The monitor does not exist": "モニターが存在しません",
        "The command has been sent": "コマンドが送信されました",
        "The group does not exist": "グループが存在しません",
        "The command does not exist": "コマンドが存在しません",
        "Setting does not exist": "設定が存在しません",
        "The settings profile does not exist": "設定プロファイルが存在しません",
        "The update package does not exist": "更新プログラム・パッケージが存在しません",
        "The update package record does not exist": "更新パッケージ・レコードが存在しません",
        "Invalid password format。 It must be between 8 and 30 characters long。": "パスワード形式が無効です。長さは 8 から 30 文字の間でなければなりません。",
        "Password format is incorrect, password must include at least three types of the following: uppercase letters, lowercase letters, digits, and special characters": "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型",
        "The field is empty": "フィールドが空です",
        "Update time cannot be null": "アップグレード時間を空白にすることはできません",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。": "更新時刻が無効です。現在の時刻より前または 30 日を超える将来の日付を指定することはできません。",
        "Uploaded file is null": "アップロードファイルが空です",
        "Uploaded file format is incorrect， file format can only be zip/exe/dmg/app": "アップロードファイルの形式が正しくありません。ファイル形式はzip/exe/dmg/appのみです",
        "Uploaded file format is incorrect， file cannot have no extension": "アップロードファイルの形式が正しくありません、ファイルに接尾辞がないことはできません",
        "Login failed。 Make sure you entered the correct account ID and password。": "ログインに失敗しました。正しいアカウント ID とパスワードを入力したことを確認してください。",
        "Date": "日付",
        "Time": "時間",
        "The data will be permanently deleted": "この操作により、現在のデータが永久に削除されます。続行するかどうか?",
        "Please select an item to delete first": "削除する前にアイテムを選択してください",
        "Select an item and then delete":"項目を選択して削除",
        "Begin Download": "ダウンロードの開始",
        "Start Download":"ダウンロードを開始",
        "Password incorrect": "パスワードが正しくありません",
        "Password Changed Successfully": "修改密码成功",
        "Display ID or Group ID is empty": "显示器id或组id为空",
        "Select the update package": "更新パッケージの選択",
        "Username already exists": "ユーザー名はすでに存在します",
        "Executing monitor setting command。Please wait 10s before making new changes。": "このモニタ設定コマンドは実行中です。10 s待ってから、新しい設定を行ってください",
        "Close": "オフ",
        "Role does not exist。 Cannot modify role。": "ロールは存在せず、ロールを変更できません",
        "Unknown Command": "不明なコマンド",
        "Access Token Expired": "アクセストークンの有効期限が切れています",
        "Invalid Refresh Token": "無効なリフレッシュトークン",
        "Missing Request Parameters:": "要求パラメータがありません:",
        "Incorrect Request Parameter Type:": "请求参数类型错误:",
        "Request URL Not Found:": "要求アドレスが存在しません:",
        "Incorrect Request Method:": "要求方法が正しくありません:",
        "Log In": "ログイン",
        "account ID": "アカウント",
        "password": "パスワード",
        "Update failed": "更新に失敗しました",
        "Reset Password?": "パスワードのリセット",
        "Logged in successfully": "正常にログインしました",
        "Please contact the system administrator to reset your password": "パスワードのリセットについては、システム管理者にお問い合わせください。",
        "Retry limit exceeded。 Please try again after 30 minutes": "再試行は5回を超えますので、30分後に再試行してください",
        "Enter the model / host name / firmware version number": "モデル/ホスト名/ファームウェアのバージョン番号を入力します",
        "New Group": "新しいグループ",
        "Delete Group": "グループの削除",
        "Display Columns": "列を表示する",
        "Collapse": "折りたたむ",
        "Expand": "展開する",
        "Move To": "移動先",
        "Export": "エクスポート",
        "Power On": "電源オン",
        "Power Off": "電源オフ",
        "Screen lock": "屏幕锁定",
        "Unlock screen": "屏幕解锁",
        "Settings": "設定",
        "Export Settings Profiles": "設定プロファイルのエクスポート",
        "Update": "更新",
        "Delete Monitor": "モニターの削除",
        "Total devices": "合計デバイス数",
        "Selected devices": "選択したデバイス",
        "Update package name": "更新パッケージ名",
        "Update Time": "更新時刻",
        "Apply to all displays of the same model": "应用于同型号显示器",
        "Display Settings": "ディスプレイの設定",
        "Select All": "すべて選択",
        "Settings Profiles": "設定プロファイル",
        "Filename": "ファイル名",
        "Group": "グループ",
        "Monitor Model": "モニター・モデル",
        "Special ID": "特殊 ID",
        "Host Name": "ホスト名",
        "Host Status": "ホストのステータス",
        "Monitor Status": "モニターのステータス",
        "Lock Status": "锁定状态",
        "Update Progress": "更新の進行状況",
        "Settings Profile": "設定プロファイル",
        "Tips": "ヒント",
        "Active Time": "アクティブ時間",
        "Overclock": "超频",
        "Operation successful": "操作は成功しました",
        "Please save data": "データを保存してください",
        "Select the data first": "最初にデータを選択する",
        "Cannot modify when ungrouped": "グループ化されていない場合は変更できません",
        "Deselect All": "すべて選択解除",
        "Select the GAMMA node label value": "GAMMA ノードのラベル値を選択します",
        "Ungrouped": "グループ化されていません",
        "Offline": "オフライン",
        "Online": "オンライン",
        "Power on": "電源を入れる",
        "Power off": "電源を切る",
        "Locked": "ロック済み",
        "Open": "ロック解除",
        "Open": "ロック解除済み",
        "Unlocked":"ロック解除済み",
        "Not connected": "接続されていません",
        "Connected": "せつぞく",
        "Set the update start time": "更新開始時刻を設定する",
        "Now": "今すぐ",
        "Set upgrade mode": "设置升级模式",
        "Interactive Mode": "インタラクティブ・モード",
        "Silent mode": "サイレント・モード",
        "In this mode， a monitor firmware update screen appears and requests confirmation to proceed。Users may choose to postpone the update twice，after which the update is mandatory。": "このモードでは、モニターのファームウェア更新画面が表示され、続行するためのユーザーの確認が求められます。ユーザーは更新を 2 回延期することを選択できますが、その後は更新が強制されます。",
        "In this mode， when the monitor is online， the firmware update will be automatically performed in the background。 Users will not see any notifications。 The update will take effect when the display is restarted。 The restart of the monitor takes about a few seconds， and won’t affect any ongoing tasks on your computer。": "このモードでは、モニターがオンラインになると、ファームウェアの更新がバックグラウンドで自動的に実行されます。ユーザーには通知が表示されません。更新は、ディスプレイを再起動すると有効になります。モニターの再起動には数秒かかりますが、コンピューターで進行中のタスクには影響しません。",
        "Invalid input": "無効な入力です",
        "Failed to log in": "ログインに失敗しました",
        "Select your preferred restart time。": "使用状況に基づいて、希望する再起動時間を選択します。",
        "You have still selected the group that the device currently belongs to。 If you want to move the device， please select another group。": "您点击的仍是设备现属组，若要移动，请选其他组。",
        "Enter the group name": "グループ名を入力してください",
        "Apply profile:": "プロファイルの適用:",
        "A new version is available": "新しいバージョンが利用可能です",
        "Restart monitor immediately after update": "更新後すぐにモニターを再起動します",
        "Restart when the monitor enters sleep mode": "モニターがスリープ状態に入ったときに再起動",
        "Restart monitor when it disconnected from all PCs": "モニタがすべてのPCから切断されたときに再起動",
        "Enter the model name": "モデル名を入力してください",
        "Create Update Task": "更新タスクの作成",
        "Update Task List": "タスク・リストの更新",
        "Cancel All": "すべてキャンセル",
        "View Details": "詳細の表示",
        "Update Details": "詳細の更新",
        "Update Mode": "更新モード",
        "Update Creation Time": "作成時刻の更新",
        "Update Start Time": "開始時刻の更新",
        "Are you sure you want to cancel all tasks?": "すべてのタスクをキャンセルしてもよろしいですか?",
        "Are you sure you want to cancel this task?": "このタスクをキャンセルしますか？",
        "Are you sure you want to delete the selected monitor?": "選択したモニターを削除してもよろしいですか?",
        "Confirm to delete all displays?": "确认要删除所有显示器吗？",
        "Are you sure you want to delete this？（Cannot delete when ungrouped）": "これを削除してもよろしいですか? (グループ化されていない場合は削除できません)",
        "Tip: If an option in the display settings appears grayed out， it may be restricted by another setting。 Try adjusting other settings to remove the restriction。": "ヒント: ディスプレイの設定のオプションがグレー表示されている場合は、別の設定によって制限されている可能性があります。他の設定を調整して、制限を解除してみてください。",
        "The WebSocket connection has been restored": "WebSocket 接続が復元されました。",
        "The previous setting is currently being applied。 Please wait until the value changes before making any new settings。": "上一设置正在执行中，请等待数值变化后，再进行新的设置",
        "Please copy this password into the input box: ": "このパスワードを入力ボックスにコピーしてください: ",
        "Ebook": "電子ブック",
        "largest": "最大",
        "Max":"最大",
        "Turn off auto mode": "自動モードをオフにする",
        "Minimum": "最小",
        "Restore Factory Settings": "工場出荷時の設定に戻す",
        "Scenario Mode": "シナリオモード",
        "Color Gamut & Color Temperature": "色域及び色温度",
        "Close PIP, PBP":"閉じる",
        "PIP window":"PIP",
        "PBP window":"PBP",
        "Panel Native": "ネイティブ パネル",
        "Neutral": "中間",
        "Neutral(7500K)":"中間",
        "Reddish(6500K)":"暖色",
        "Bluish(9300K)":"寒色",
        "Warm": "暖色",
        "Cool": "寒色",
        "Low Blue Light": "ブルーライト低減",
        "Custom 1": "カスタム1",
        "Custom 2": "カスタム2",
        "Custom 3": "カスタム3",
        "BT.709": "BT.709",
        "BT.2020": "BT.2020",
        "Video Signal": "映像信号",
        "Game Mode": "ゲームモード",
        "Off": "オフ",
        "Game 1": "ゲーム 1",
        "Game 2": "ゲーム 2",
        "Response Time": "応答速度",
        "Normal": "ノーマル",
        "Extreme": "エクストリーム",
        "Level 1": "レベル1",
        "Level 2": "レベル2",
        "Level 3": "レベル3",
        "Level 4": "レベル4",
        "Level 5": "レベル5",
        "Lan Indicator": "LANステータス表示",
        "Linked": "リンク成功",
        "No Link": "リンクなし",
        "Blinking": "通信中",
        "Brightness": "コントラスト",
        "Contrast": "明るさ",
        "Smart Light": "スマート・ライト",
        "Volume Control": "音量を調整する",
        "USB Select": "USB設定",
        "DP Select": "DP設定",
        "Aspect Ratio": "アスペクト比",
        "Smart Traffic Light": "トラフィックライト",
        "daisy chain": "デイジーチェーン",
        "Dynamic Contrast": "动态对比度",
        "Smart Energy": "スマートエネルギー",
        "Smart Audio": "スマートオーディオ",
        "Distance Warning": "距離警告",
        "Ambient Light Detection": "環境光の検出",
        "Enabled Ambient Light Detection": "環境光の検出を有効にする",
        "enabled":"きょうようのかいし",
        "disabled":"disabled",
        "Waken on Touch": "タッチ操作で起動",
        "True Split": "トゥルー・スプリット",
        "Face Tracking": "フェイス・トラッキング",
        "Audio Smart Switch": "音声スマート機能",
        "Auto-alarm": "自動警報",
        "KVM Switch": "KVMスイッチ",
        "KVM切换": "KVMスイッチ",
        "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor, keyboard and mouse, Enable switching video, keyboard and mouse simultaneously. If disabled, only switch keyboard and mouse.": "KVM（キーボード/ビデオ/マウス）スイッチにより、2台のPCを1組のディスプレイ、キーボード、マウスで切り替えて操作できます、ディスプレイ、キーボード、マウスの同時切り替えを有効にします。無効にすると、キーボードとマウスのみを切り替えます",
        "Sitting Reminder": "姿勢通知",
        "Gaming": "ゲーム",
        "RGB Gain": "色の調整",
        "Serial No": "シリアル番号",
        "Firmware Version": "ファームウェアのバージョン",
        "Select response time level": "応答速度の設定",
        "Enable daisy chain": "デイジーチェーンを有効にする",
        "Smart Traffic Light is a do not disturb light, helping to reduce distraction": "スマート・トラフィック・ライトは集中モードライトで、気が散るのを軽減します",
        "Enable/Disable the Audio Smart function": "音声スマート機能を有効/無効にする",
        "Auto-alarm indicates whether the camera/MIC on monitor is in use": "自動警報はモニター上のカメラ/マイクの使用状況を表示する",
        "Enable Distance Warning": "距離警告を有効にする",
        "Enable/disable face tracking": "フェイス・トラッキングを有効/無効にする",
        "Enable Sitting Reminder": "姿勢通知を有効にする",
        "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity": "スマートオーディオ技術は、音声の明瞭度を向上させ、目の前の音に集中することができます",
        "Smart Energy technology automatically manages energy consumption by human detection sensor": "スマート エネルギーは人感センサーで消費電力を自動的に制御する機能です",
        "Implement PBP through only one cable": "ケーブル1本の接続で、PIPやPBPのような画面分割機能を実現します",
        "Enable/Disable vPro technology in the monitor": "モニター内のvProテクノロジーを有効/無効にする",
        "Wake system by touch": "タッチ操作でシステム起動",
        "Set video source and USB source (used by keyboard and mouse) for every PC": "各PCの映像ソース及びUSBソース（キーボード・マウス）を設定します",
        "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse": "マウス操作で、2台のPC間のアクティブなマウス・キーボードを切り替える",
        "Enable USB charging always on": "USB充電を常に有効にします",
        "Select DP version": "DP（DisplayPort）のバージョンを選択する",
        "USB Charging": "USB充電",
        "PC": "PC",
        "Double-click the CTRL": "Ctrlキーのダブルクリック",
        "Full Screen": "フルスクリーン",
        "Original AR": "オリジナルの比率",
        "No scaling": "スケーリングなし",
        "on": "オープン",
        "On": "オープン",
        "Keyboard On": "キーボード使用",
        "Mouse On": "マウス使用",
        "Image Creation": "写真編集・イラスト",
        "Digital Cinema": "デジタルシネマ",
        "Video Creation": "映像制作",
        "Web Browsing": "ウェブブラウジング",
        "Professional Image": "専門画像",
        "DisplayPort": "DisplayPort",
        "Auto": "自動",
        "Refresh": "更新",
        "Search": "検索",
        "Record": "記録",
        "Username": "ユーザー名",
        "Upload Time": "アップロード時間",
        "Add Profiles": "プロファイルの追加",
        "Latest Update Package": "最新の更新パッケージ",
        "Upload Update Package": "更新パッケージをアップロード",
        "Upload": "アップロード",
        "Size": "サイズ",
        "Upload successful": "アップロード成功",
        "Download successful": "ダウンロード成功",
        "Refresh successful": "更新に成功しました",
        "The upgrade package does not match the device model": "アップグレードパッケージと機種が一致しません",
        "Upgrade package does not match the device model":"アップグレード・パッケージがデバイス・モデルと一致しません",
        "Please enter the setting name": "設定名を入力してください",
        "Edit": "編集",
        "Save": "保存",
        "Delete": "削除",
        "Add": "追加",
        "Reset Password": "パスワードのリセット",
        "No": "番号",
        "Full Name": "フル・ネーム",
        "Role": "役割",
        "Creation Date": "作成日",
        "Operation": "操作",
        "Actions": "操作",
        "The password has been reset to：": "パスワードは次にリセットされました: ",
        "Invalid input。Usernames can only contain numbers and letters。": "無効な入力です。ユーザー名は数字と文字で構成されています。",
        "Invalid input。The username must contain 4 to 30 characters。": "無効な入力です。ユーザー名は 4 〜 30 文字にする必要があります。",
        "Installation Package": "インストール・パッケージ",
        "Operation Date": "操作日",
        "Actions": "アクション",
        "Operator": "オペレーター",
        "Paging component": "ページングコンポーネント",
        "Quick page flipping": "クイックページフリップ",
        "Current page": "現在のページ",
        "Title": "タイトル",
        "Details": "詳細",
        "This is the expanded area": "これが拡張されたエリアです",
        "Set Display Column": "表示列を設定",
        "Upload file": "ファイルをアップロード",
        "Drop-down to expand": "拡張するドロップダウン",
        "Default": "デフォルト",
        "Default Info": "デフォルト情報",
        "Personal Center": "パーソナルセンター",
        "Personal center image button": "パーソナルセンターイメージボタン",
        "Expandable area": "拡張可能なエリア",
        "Update Package Table": "パッケージテーブルを更新",
        "This is the table header": "これはテーブルヘッダーです。",
        "This is the table content": "これはテーブル内容です。",
        "UserList Table": "ユーザーリストテーブル",
        "Page Up and Down": "ページアップ＆ダウン",
        "Operation record table": "操作記録テーブル",
        "OSD upgrade details": "OSDアップグレードの詳細",
        "Lenovo": "Lenovo",
        "Display Fleet Manager": "Display Fleet Manager",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gama": "Gama",
        "PIP/PBP": "PIP/PBP",
        "OSD": "OSD",
        "USB-C Charging": "USB-C 充電",
        "PIP": "PIP",
        "PBP": "PBP",
        /*
        "Simplified Chinese": "簡体字中国語",
        "English": "英語",
        "Traditional Chinese": "繁体字中国語",
        "French": "フランス語",
        "German": "ドイツ語",
        "Italian": "イタリア語",
        "Spanish": "スペイン語",
        "Japanese": "日本語",
        "Thai": "タイ語",
        "Ukrainian": "ウクライナ語",
        "Russian": "ロシア語",
        */
        "Enter your account ID": "アカウント ID を入力してください",
        "Please Enter your account id":"パスワードのリセットについては、システム管理者にお問い合わせください。",
        "Enter your password": "パスワードを入力してください",
        "Cannot exceed 20 characters": "20 文字を超えることはできません",
        "Enter the original password": "元のパスワードを入力してください",
        "You have still selected the group that the device currently belongs to. If you want to move the device, please select another group. ": "デバイスが現在属しているグループがまだ選択されています。デバイスを移動する場合は、別のグループを選択してください。",
        "Enter the filename": "ファイル名 を入力",
        "Update Package Name": "更新パッケージ名",
        "Select the date": "日付の選択",
        "Select the time": "時間の選択",
        "Set the update mode": "更新モードの設定",
        "Restart when the monitor is not connected to any computer": "モニターがどのコンピューターにも接続されていないときに再起動",
        "Invalid file format": "ファイル形式が無効です。zip/exe/dmg/app ファイルのみがサポートされています。",
        "Select a valid file type": "有効なファイルタイプを選択してください",

        "The data is being processed。 Please do not submit again。": "データは処理中です。再度送信しないでください。",
        "Enter the profiles name": "プロファイル名を入力してください",
        "Enter your username": "ユーザー名を入力してください",
        "Enter your full name": "フル・ネームを入力してください",
        "The initial password of this user is:": "このユーザーの初期パスワード:",
        "Select your role": "役割を選択してください",
        "User Profile": "ユーザー・プロファイル",
        "Downloading": "ダウンロード中…",
        "Enter the new password again。Two times of new password input is same": "新しいパスワードをもう一度入力してください。新しいパスワードは前の入力内容に一致する必要があります。",
        "Request failed with status code 502": "ステータスコード 502 で要求失敗",

        "Please Enter your x": "{param} を入力",
        "Select the x": "{param} を選択",
        "Please select the correct file type x": "有効なファイルタイプを選択してください{param}",
        "Please select the correct file type": "有効なファイルタイプを選択してください",
        "Input characters within x characters": "入力文字は{param}}文字以内",

        "Monitor List":"モニター・リスト",
        "List of update packages":"更新パッケージ一覧",
        "Settings - Profiles":"設定 - プロファイル",
        "User Management":"ユーザー管理",
  

        "Simplified Chinese": "简体中文",
        "English": "English",
        "Traditional Chinese": "繁體中文",
        "French": "Français",
        "German": "Deutsch",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "日本語",
        "Thai": "ภาษาไทย",
        "Ukrainian": "Українська",
        "Russian": "Русский язык",

        "System abnormality":"システム異常",

        "Upgrade Package Record ID is empty":"更新パッケージの選択",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。":"更新時間が無効です。現在の時間よりも早く、将来の30日を超えることはできません。",
      
        "Request parameter is invalid:The username must contain 4 to 30 characters。":"リクエストパラメータは無効です:ユーザー名は4〜30文字を含む必要があります",
        "The WebSocket connection has been lost Reconnecting":"WebSocket 接続が失われました 再接続",
        "Request parameter is invalid：Usernames can only contain numbers and letters。":"要求パラメータは無効です:ユーザー名は数字と文字で構成されています。",


        "Request parameter is invalid:Password length must be between 8-16 character":"要求パラメータは無効です:パスワードの長さは8-16文字の間でなければなりません。",
        "The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling":"コンパイルされたパッケージが欠けている：コンポーネントにはアップロードされていない対応するビンがあります。コンパイルする前にアップロードしてください。",

        "Request parameter is invalid：Password length must be 8–16 characters":"要求パラメータは無効です:パスワードの長さは8-16文字の間でなければなりません",


        "Illegal request header!": "不正な要求ヘッダー",
        "Invalid request parameters":"無効な要求パラメータ",
        "Export": "エクスポート機能",
        "It is already a high-version and there is no need to upgrade":"既にハイバージョンであり、アップグレードする必要はありません",
        "Repeated request， please try again later":"繰り返しリクエストが発生しました。後ほどもう一度お試しください。",
        "Communication":"しぐなりんぐ"
    }
}